import { render, staticRenderFns } from "./Onhand.vue?vue&type=template&id=32356282"
import script from "./Onhand.vue?vue&type=script&lang=js"
export * from "./Onhand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports